import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAnglesRight } from "@fortawesome/free-solid-svg-icons";
import "./../../UaeAttestation/UaeService/UaeService.css";
const AustraliaServiceMain = () => {
  return (
    <div className="uaeServiceMainContainer">
      <ul>
        <li>
          <FontAwesomeIcon
            icon={faAnglesRight}
            className="eduCertIcon"
          ></FontAwesomeIcon>{" "}
          An apostille is a rectangular sticker that verifies the authenticity
          of personal, educational, and business documents. Apostilles can only
          be provided for documents issued in one of the Hague Apostille
          Convention's member countries and intended for use in another Hague
          Convention member nation.
        </li>
        <li>
          <FontAwesomeIcon
            icon={faAnglesRight}
            className="eduCertIcon"
          ></FontAwesomeIcon>{" "}
          Apostille is a type of international attestation that is recognized in
          over 112 countries throughout the world. India is a signatory to the
          Apostille Convention and has selected the same authority for both
          attestation and apostille documents for Australia. As a signatory
          party to the Hague Convention, Australia is an apostille country. The
          Ministry of External Affairs stamps Apostilles only on genuine
          documents that have been legally validated by the designated
          authorities of the State Governments (HRD) / Sub-Divisional Magistrate
          (MEA).
        </li>
        <li>
          <FontAwesomeIcon
            icon={faAnglesRight}
            className="eduCertIcon"
          ></FontAwesomeIcon>{" "} 
          Documents issued in Australia such as a Diploma, M Phil, Birth,
          Impediment to Marriage, Degree, Post-Graduation, and Police Clearance
          Certificate must first be notarized before being Apostilled or
          Legalized by the Department of Foreign Affairs and Trade, or DAT, in
          order to be used internationally. Goodway Attestation provides the
          best and most reliable apostille Australia certificate service in
          Bangalore. We complete the process timely. We have a team of experts
          that get the apostille documents for Australia without any hassle.
        </li>
      </ul>
    </div>
  );
};

export default AustraliaServiceMain;
